<template>
<div class="radio" :class="{'on': checked}" v-on="{ [isTouch ? 'touchstart' : 'click']: toggle }" :data-title="title">
  <div class="radio-check" :class="css">
    <i class="icon icon-check"></i>
  </div>
  <slot></slot>
</div>
</template>
<script>
export default {
  name: 'baseradio',
  props: {
    on: Boolean,
    css: String,
    title: String,
    isTouch: Boolean
  },
  data () {
    return {
      checked: this.on
    }
  },
  components: {
  },
  computed: {
  },
  watch: {
    on () {
      this.checked = this.on
    }
  },
  methods: {
    toggle () {
      this.checked = !this.checked
      this.$emit('change')
    }
  },
  mounted () {
  }
}
</script>
